import { createSlice } from '@reduxjs/toolkit';
import { OMSAUTH, OMSPROFILE } from '../../API';
import { logFrontendActivity } from '../General/activityLogger';

export const authslice = createSlice({
    name: 'postLogin',
    initialState: {
        isLoggedIn: false,
        profile: {},
        notification: { showMessage: false, messageContent: "", messageType: "success" },
        loginLoading: true,
        logoutLoading: false,
        resetLoading: false,
        resetFail: false
    },

    reducers: {
        postLogin: (state) => {
            return {
                ...state,
                loginLoading: true
            }
        },
        postLoginSuccess: (state, action) => {
            return {
                ...state,
                isLoggedIn: true,
                loginLoading: false,
                profile: action && action.payload && action.payload.data && action.payload.data.data
            }
        },
        postLoginFailure: (state, action) => {
            return {
                ...state,
                isLoggedIn: false,
                loginLoading: false,
                notification: { showMessage: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message ? action.payload.data.message : 'Failed to authenticate', messageType: "error" },
            }
        },

        resetNotificationData: (state, action) => {
            return {
                ...state,
                loading: true,
                notification: { showMessage: false, messageContent: "", messageType: "success" }
            }
        },
        verifyAuth: (state, action) => {
            return {
                ...state,
                loginLoading: true
            }
        },
        verifyAuthSuccess: (state, action) => {
            return {
                ...state,
                isLoggedIn: true,
                loginLoading: false,
                logoutLoading: false,
                profile: action && action.payload && action.payload.data && action.payload.data.data
            }
        },
        verifyAuthFailure: (state, action) => {
            return {
                ...state,
                isLoggedIn: false,
                loginLoading: false,
                logoutLoading: false,
            }
        },
        postLogout: (state) => {
            return {
                ...state,
                logoutLoading: true
            }
        },
        postLogoutSuccess: (state) => {
            return {
                ...state,
                isLoggedIn: false,
                logoutLoading: false,
            }
        },
        postLogoutFailure: (state) => {
            return {
                ...state,
                isLoggedIn: false,
                logoutLoading: false,
            }
        },
        postRegister: (state) => {
            return {
                ...state,
                loginLoading: true,
                notification: { showMessage: false, messageContent: "", messageType: "success" }
            }
        },
        postRegisterSuccess: (state, action) => {
            return {
                ...state,
                isLoggedIn: true,
                loginLoading: false,
                profile: action && action.payload && action.payload.data && action.payload.data.data
            }
        },
        postRegisterFailure: (state, action) => {
            return {
                ...state,
                isLoggedIn: false,
                loginLoading: false,
                logoutLoading: false,
                notification: { showMessage: true, messageContent: action.payload && action.payload.data && action.payload.data.message, messageType: "error" }
            }
        },
        postPasswordReset: (state) => {
            return {
                ...state,
                resetLoading: true
            }
        },
        postPasswordResetSuccess: (state, action) => {
            return {
                ...state,
                resetLoading: false,
                isLoggedIn: false,
                notification: { showMessage: true, messageContent: action.payload && action.payload.data && action.payload.data.msg, messageType: "success" }
            }
        },
        postPasswordResetFailure: (state, action) => {
            return {
                ...state,
                resetLoading: false,
                isLoggedIn: false,
                notification: { showMessage: true, messageContent: action.payload && action.payload.data && action.payload.data.errors, messageType: "error" }
            }
        },
        postQuestionerData: (state) => {
            return {
                ...state,
                loginLoading: true,
                hasErrors: false
            }
        },
        postQuestionerDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loginLoading: false,
                notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" }

            }
        },
        postQuestionerDataFailure: (state, action) => {
            return {
                ...state,
                loginLoading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
            }
        },
        postResendEmail: (state) => {
            return {
                ...state,
                resentEmailloading: true,
                resentEmail: false
            }
        },
        postResendEmailSuccess: (state, action) => {
            return {
                ...state,
                resentEmail: true,
                resentEmailloading: false,
                notification: { showMessage: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message ? [action.payload.data.data.message] : "Something went wrong", messageType: "success" },
            }
        },
        postResendEmailFailure: (state, action) => {
            return {
                ...state,
                resentEmail: false,
                resentEmailloading: false,
                notification: { showMessage: true, messageContent: action && action.payload && action.payload.data && action.payload.data.data  && action.payload.data.data.message ? ["Something went wrong"] : ["Something went wrong"], messageType: "error" },
            }
        },

    }
})

export const doLogin = data => dispatch => {
    dispatch(postLogin());
    try {

        OMSAUTH.get('/csrf-cookie').then(response => {
            OMSAUTH.post('/login', data).then(function (response) {
                OMSPROFILE.get('/profile').then(function (response) {
                    dispatch(postLoginSuccess(response));
                    dispatch(resetNotification());
                }).catch(function (error) {
                    dispatch(postLoginFailure(error.response));
                    dispatch(resetNotification());
                })
            }).catch(function (error) {
                dispatch(postLoginFailure(error.response));
            })
        }).catch(function (error) {
            dispatch(postLoginFailure(error.response));
        });
    }
    catch (error) {
        dispatch(postLoginFailure(error));
    }
}

export const authenticate = data => dispatch => {
    dispatch(verifyAuth());
    try {
        OMSPROFILE.get('/profile')
            .then(function (response) {
                dispatch(verifyAuthSuccess(response));
            }).catch(function (error) {
                dispatch(verifyAuthFailure(error));
            })
    }
    catch (error) {
        dispatch(verifyAuthFailure(error));
    }
}

export const doLogout = data => dispatch => {

    dispatch(postLogout())

    try {
        OMSAUTH.post('/logout')
            .then(function (response) {
                dispatch(postLogoutSuccess());
            })
            .catch(function (error) {
                dispatch(postLogoutFailure());
            })
    }
    catch (error) {
        dispatch(postLogoutFailure())
    }
}

export const doRegister = data => dispatch => {
    dispatch(postRegister());
    try {
        OMSAUTH.get('/csrf-cookie').then(response => {
            OMSAUTH.post('/register', data).then(function (response) {
                OMSPROFILE.get('/profile').then(function (response) {
                    dispatch(postRegisterSuccess(response));
                }).catch(function (error) {
                    dispatch(postRegisterFailure(error.response));
                })
            }).catch(function (error) {
                dispatch(postRegisterFailure(error.response));
            })
        }).catch(function (error) {
            dispatch(postRegisterFailure(error.response));
        });

    }
    catch (error) {
        dispatch(postRegisterFailure(error.response));
    }
}

export const doPasswordReset = (userid,data) => dispatch => {
    dispatch(postPasswordReset());
    const logRef = crypto.randomUUID();
    try {
        OMSAUTH.post('/resetpassword', data).then(function (response) {
            dispatch(postPasswordResetSuccess(response));
            logFrontendActivity({
                group: 'AUTH',
                subgroup: 'PASSWORD_RESET',
                action: 'SUCCESS',
                request_data: data,
                response_data: response.data,
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }else{
                    console.log('Activity log failed:', ref);
                }
            });
        }).catch(function (error) {
            dispatch(postPasswordResetFailure(error.response));
            logFrontendActivity({
                group: 'AUTH',
                subgroup: 'PASSWORD_RESET',
                action: 'FAILURE',
                request_data: data,
                response_data: error.response?.data || {},
                log_ref: logRef,
                userid: userid
            }).then((ref) => {
                if (ref) {
                    console.log('Activity log recorded with log_ref:', ref);
                }
            });
        })

    }
    catch (error) {
        dispatch(postPasswordResetFailure(error));
        logFrontendActivity({
            group: 'AUTH',
            subgroup: 'PASSWORD_RESET',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}


export const storeQuestionerData = (userid,data) => dispatch => {
    dispatch(postQuestionerData());
    const logRef = crypto.randomUUID();
    console.log(data)
    try {
        OMSPROFILE.post('/questioner-data', data)
            .then(function (response) {
                dispatch(postQuestionerDataSuccess(response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'QUESTIONER_DATA',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postQuestionerDataFailure(error.response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'QUESTIONER_DATA',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postQuestionerDataFailure(error.response));
        logFrontendActivity({
            group: 'ONBOARDING',
            subgroup: 'QUESTIONER_DATA',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const resendEmail = (userid,email) => dispatch => {
    dispatch(postResendEmail());
    const logRef = crypto.randomUUID();
    try {
        OMSAUTH.post('/verify/resend/'+email+'/LABELGEN', {})
            .then(function (response) {
                dispatch(postResendEmailSuccess(response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'VERIFY_EMAIL_RESEND',
                    action: 'SUCCESS',
                    request_data: email,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postResendEmailFailure(error.response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'VERIFY_EMAIL_RESEND',
                    action: 'FAILURE',
                    request_data: email,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postRegisterFailure(error.response));
        logFrontendActivity({
            group: 'ONBOARDING',
            subgroup: 'VERIFY_EMAIL_RESEND',
            action: 'FAILURE',
            request_data: email,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const resetNotification = data => dispatch => {    
    dispatch(resetNotificationData());
}
export const { postLogin, postLoginSuccess, postLoginFailure, verifyAuth, verifyAuthSuccess, verifyAuthFailure, postLogout, postLogoutSuccess, postLogoutFailure, postRegister, postRegisterSuccess, postRegisterFailure, postPasswordReset, postPasswordResetSuccess, postPasswordResetFailure, resetNotificationData,postQuestionerData,postQuestionerDataSuccess,postQuestionerDataFailure, postResendEmail,postResendEmailSuccess, postResendEmailFailure } = authslice.actions;

export default authslice.reducer;
